// **************************
// *** AgendamentosConcluidos concluidos.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 17/06/24 | 15:02h
// *** 4/7/24 | 09h39 → acrescentado o token criptografado
// *** 14/11/24 | 13h54 → corrigido e melhorado a paginação em ambos os tipos de atendimento (tipoAtendimento = 0 ou 1)
// **************************



import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import Menu from "../../components/Menu/menu.jsx";
import CardAgendamentos from "../../components/Agendamentos/agendamentos.jsx";
import Footer from "../../components/Footer/footer.jsx";
import handleApiError from '../../../../Services/apiErrorHandler.js';

import './concluidos.css';

function AgendamentosConcluidos() {
    const getInitialUserData = () => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return {
                    userId: decryptedUser.id_usuario || 0,
                    tam_pagina: decryptedUser.TAMANHO_PAGINA || 10
                };
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                return { userId: 0, tam_pagina: 0 };
            }
        }
        return { userId: 0, tam_pagina: 0 };
    };

    const initialUserData = getInitialUserData();
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.tam_pagina);
    const [id_usuario, setId_usuario] = useState(initialUserData.userId);

    const [nenhumAgendamentoConcluidoEncontrado, setNenhumAgendamentoConcluidoEncontrado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);
    useEffect(() => {
        atualizarAgendamentos(pagina);
    }, [pagina]);

    const atualizarAgendamentos = (pagina) => {
        setLoading(true);
        const url = `reserva/listar?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=5`;
        apiaxios.get(url)
            .then((response) => {
                setLoading(false);
                
                if (response.data.retorno) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro ao carregar agendamentos: ' + response.data.retorno,
                        timer: 3000,
                        timerProgressBar: true
                    });
                } else {
                    if (response.data.length === 0) {
                        setNenhumAgendamentoConcluidoEncontrado(true);
                        MySwal.fire({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            icon: 'info',
                            title: 'Nenhum agendamento concluído encontrado neste momento...'
                        });
                        setHasMore(false);
                    } else {
                        setNenhumAgendamentoConcluidoEncontrado(false);
                        setAgendamentos(prevDados => [...prevDados, ...response.data]);
                        if (response.data.length < tamanho_pagina) {
                            setHasMore(false);
                        }
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                handleApiError(error);
            });
    };
    
    const handleAvaliar = async (agendamento) => {
        const { ID_RESERVA, ID_EMPRESA, NOME, DESCRICAO } = agendamento;
        
        // Primeira requisição para buscar as avaliações do prestador
        try {
            const response = await apiaxios.get(`/reserva/avaliacao?id_usuario=${ID_EMPRESA}&tipo_avaliacao=P`);
            const { avaliacao, quantidade, retorno } = response.data;
    
            if (retorno !== 'OK') {
                Swal.fire('Erro', retorno, 'error');
                return;
            }
    
            let selectedRating = 0;
    
            MySwal.fire({
                title: 'Qual nota você daria para este Prestador de Serviços?',
                html: `
                    <p>${NOME} (ID Reserva: ${ID_RESERVA})</p>
                    <p>${DESCRICAO}</p>
                    <div id="rating" style="display: flex; justify-content: center;">
                        ${[1, 2, 3, 4, 5].map(i => `<i class="fa fa-star" data-value="${i}" style="cursor: pointer; font-size: 2em; margin: 0 5px;"></i>`).join('')}
                    </div>
                    <p>${quantidade > 0 ? `${quantidade} avaliação${quantidade > 1 ? 's' : ''}` : 'Prestador ainda não foi avaliado. Você é o primeiro cliente a fazê-lo!'}</p>
                `,
                showCancelButton: true,
                confirmButtonText: 'Enviar Avaliação',
                cancelButtonText: 'Voltar',
                didOpen: () => {
                    const stars = MySwal.getPopup().querySelectorAll('.fa-star');
                    stars.forEach(star => {
                        star.addEventListener('click', (e) => {
                            selectedRating = parseInt(e.target.getAttribute('data-value'));
                            stars.forEach(s => s.style.color = s.getAttribute('data-value') <= selectedRating ? 'gold' : 'gray');
                        });
                    });
                },
                preConfirm: () => {
                    if (selectedRating === 0) {
                        Swal.showValidationMessage('Por favor, selecione uma nota antes de enviar.');
                        return false;
                    }
                    return selectedRating;
                }
            }).then(result => {
                if (result.isConfirmed) {
                    // Segunda requisição para enviar a avaliação
                    const id_usuario = JSON.parse(localStorage.getItem("tokenacw")).id_usuario;
    
                    apiaxios.get(`/reserva/avaliar?id_usuario=${id_usuario}&id_reserva=${ID_RESERVA}&tipo_avaliacao=C&avaliacao=${result.value}`)
                        .then(response => {
                            if (response.status === 200 && response.data.retorno === "OK") {
                                Swal.fire('Sucesso', 'Avaliação enviada com sucesso!', 'success');
                                // Atualize a interface conforme necessário
                            } else {
                                Swal.fire('Erro', response.data.retorno || 'Erro ao enviar avaliação', 'error');
                            }
                        })
                        .catch(error => {
                            Swal.fire('Erro', 'Erro ao enviar avaliação: ' + error, 'error');
                        });
                }
            });
        } catch (error) {
            Swal.fire('Erro', 'Erro ao buscar avaliações: ' + error, 'error');
        }
    };
    
        

    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="agendamentosconcluidos" />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="container-fluid">
                                <h1 className="text-center">Agendamentos Concluídos</h1>
                                <div className="row">
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                    {nenhumAgendamentoConcluidoEncontrado ? (
                                        <div className="alert alert-danger mt-10" role="alert">
                                            Nenhum "Agendamento Concluído" disponível neste momento...
                                        </div>
                                    ) : (
                                        <div className="box-agendamentos">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Id.Reserva</th>
                                                        <th>Descrição</th>
                                                        <th>Nome Empresa</th>
                                                        <th>Endereço Empresa</th>
                                                        <th>Fone Empresa</th>
                                                        <th>Data</th>
                                                        <th>Hora</th>
                                                        <th>Valor</th>
                                                        <th className="text-right">Status</th>
                                                        <th className="text-right">Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {agendamentos.filter(agendamento => agendamento.ID_STATUS === 5).map(agendamento => ( */}
                                                    {agendamentos.map((agendamento, index) => (
                                                        <CardAgendamentos
                                                            // key={agendamento.ID_RESERVA}
                                                            key={`${agendamento.ID_RESERVA}-${index}`}
                                                            agendamento={{
                                                                agendamento_id: agendamento.ID_RESERVA,
                                                                agendamento_descricao: agendamento.DESCRICAO,
                                                                agendamento_nome: agendamento.NOME,
                                                                agendamento_data: agendamento.DATA_RESERVA,
                                                                agendamento_hora: agendamento.HORA,
                                                                agendamento_vr: agendamento.VALOR,
                                                                agendamento_endereco: `${agendamento.ENDERECO} ${agendamento.BAIRRO} - ${agendamento.CIDADE}`,
                                                                agendamento_fone: agendamento.FONE,
                                                                agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO}`
                                                            }}
                                                            showExcluir={false}
                                                            showAvaliar={agendamento.AVAL_PRESTADOR_PELO_CLIENTE < 1 && agendamento.ID_STATUS === 4} // Aqui ajustamos a propriedade showAvaliar
                                                            showMotivo={false}
                                                            handleAvaliar={() => handleAvaliar(agendamento)}
                                                            // handleAvaliar={handleAvaliar}
                                                        />
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                           
                                    )}
                                </div>
                                {hasMore && (
                                    <div className="load-more">
                                        <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AgendamentosConcluidos;